import AsyncComponent from '../components/AsyncComponent';

const Home = AsyncComponent(() => import('./Home'));
const Music = AsyncComponent(() => import('./Music'));
const MusicEdit = AsyncComponent(() => import('./MusicEdit'));
const MusicNew = AsyncComponent(() => import('./MusicNew'));
const MusicConfirm = AsyncComponent(() => import('./MusicConfirm'));
const MusicDetail = AsyncComponent(() => import('./MusicDetail'));
const MusicEditMarker = AsyncComponent(() => import('./MusicEditMarker'));
const MusicBulkUpdate = AsyncComponent(() => import('./MusicBulkUpdate'));
const Medal = AsyncComponent(() => import('./Medal'));
const MedalBulkUpdate = AsyncComponent(() => import('./MedalBulkUpdate'));
const Member = AsyncComponent(() => import('./Member'));
const MemberDetail = AsyncComponent(() => import('./MemberDetail'));
const MemberPoint = AsyncComponent(() => import('./MemberPoint'));
const MemberEdit = AsyncComponent(() => import('./MemberEdit'));
const MemberNew = AsyncComponent(() => import('./MemberNew'));
const MemberBulkUpdate = AsyncComponent(() => import('./MemberBulkUpdate'));
const Employee = AsyncComponent(() => import('./Employee'));
const EmployeeConfirm = AsyncComponent(() => import('./EmployeeConfirm'));
const EmployeeEdit = AsyncComponent(() => import('./EmployeeEdit'));
const EmployeeNew = AsyncComponent(() => import('./EmployeeNew'));
const EmployeePassword = AsyncComponent(() => import('./EmployeePassword'));
const EmployeeDetail = AsyncComponent(() => import('./EmployeeDetail'));
const Point = AsyncComponent(() => import('./Point'));
const RecommendAlbum = AsyncComponent(() => import('./RecommendAlbum'));
const SongTagManage = AsyncComponent(() => import('./SongTagManage'));
const TagMasterManage = AsyncComponent(() => import('./TagMasterManage'));
const SongNlSearch = AsyncComponent(() => import('./SongNlSearch'));
const SearchLogList = AsyncComponent(() => import('./SearchLogList'));
const SongTagDetail = AsyncComponent(() => import('./SongTagDetail'));
const MusicFinish = AsyncComponent(() => import('./MusicFinish'));
const PurchaseAggregate = AsyncComponent(() => import('./PurchaseAggregate'));
const NewsEdit = AsyncComponent(() => import('./NewsEdit'));
const MailHistory = AsyncComponent(() => import('./MailHistory'));
const MailManage = AsyncComponent(() => import('./Mail'));
const MailConfirm = AsyncComponent(() => import('./MailConfirm'));
const MailFinish = AsyncComponent(() => import('./MailFinish'));
const PlaylistManage = AsyncComponent(() => import('./PlaylistManage'));
const PlaylistDetail = AsyncComponent(() => import('./PlaylistDetail'));
const PlaylistEdit = AsyncComponent(() => import('./PlaylistEdit'));
const Inquiry = AsyncComponent(() => import('./Inquiry'));
const InquiryDetail = AsyncComponent(() => import('./InquiryDetail'));
const Creator = AsyncComponent(() => import('./Creator'));
const OpenChat = AsyncComponent(() => import('./OpenChat'));
const CreatorNew = AsyncComponent(() => import('./CreatorNew'));
const CreatorEdit = AsyncComponent(() => import('./CreatorEdit'));
const Album = AsyncComponent(() => import('./Album'));


export default {
  Home,
  Music,
  MusicEdit,
  MusicNew,
  MusicConfirm,
  MusicEditMarker,
  MusicDetail,
  MusicBulkUpdate,
  Medal,
  MedalBulkUpdate,
  Member,
  MemberDetail,
  MemberPoint,
  MemberEdit,
  MemberNew,
  MemberBulkUpdate,
  MusicFinish,
  Employee,
  EmployeeDetail,
  EmployeeConfirm,
  EmployeeEdit,
  EmployeeNew,
  EmployeePassword,
  Point,
  RecommendAlbum,
  SongTagManage,
  TagMasterManage,
  SongTagDetail,
  SongNlSearch,
  SearchLogList,
  PurchaseAggregate,
  NewsEdit,
  MailManage,
  MailConfirm,
  MailFinish,
  MailHistory,
  PlaylistManage,
  PlaylistDetail,
  PlaylistEdit,
  Inquiry,
  InquiryDetail,
  OpenChat,
  Creator,
  CreatorNew,
  CreatorEdit,
  Album
};
